export const thumbsUp = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M6.125 24.5H2.625V12.25H6.125V24.5ZM17.347 4.60486C17.6258 4.88922 17.8008 5.2829 17.8008 5.71484L17.7683 6.04297L16.7839 10.5H23.302C24.4394 10.5 25.3697 11.7849 25.3698 12.9387V15.0502C25.3698 15.3235 25.3201 15.5753 25.2272 15.8158L22.1049 23.22C21.7986 23.9746 21.0929 24.5 20.2344 24.5H10.8281C9.69071 24.5 8.75017 23.5979 8.75 22.4441V11.9441C8.75 11.3644 8.97969 10.8389 9.35156 10.4616L16.2422 3.5L17.347 4.60486Z"
    fill="currentColor"
  />
);

export const thumbsDown = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M21.875 3.5H25.375V15.75H21.875V3.5ZM10.6529 23.3951C10.3742 23.1108 10.1993 22.7171 10.1993 22.2851L10.2317 21.957L11.2161 17.5H4.698C3.56061 17.5 2.63031 16.2151 2.63013 15.0613V12.9498C2.63014 12.6765 2.67988 12.4247 2.77283 12.1842L5.89515 4.78003C6.2014 4.02534 6.90703 3.5 7.76562 3.5H17.1719C18.3093 3.5 19.2498 4.40217 19.25 5.55591V16.0559C19.25 16.6356 19.0203 17.1611 18.6484 17.5384L11.7578 24.5L10.6529 23.3951Z"
    fill="currentColor"
  />
);
